import { store } from 'reducers'

export const canEditLoanApplication = (ignoreSign = false) => {
  let rlt = true
  const { auth, loanDetail, borrower } = store.getState()
  if (!ignoreSign && !loanDetail.restructureApplicationRelease) rlt = false
  const matched = auth?.role?.role?.permissions?.find(
    (permissionName: string) => permissionName === 'Loan.Detail.Override',
  )
  if (matched) rlt = true
  if (!ignoreSign) {
    Object.keys(borrower).forEach((key) => {
      if (borrower[key].isIncluded && !!borrower[key].signedDate) rlt = false
    })
  }
  return rlt
}

export const canEditLoanApplicationForBorrower = (borrowerSeperator?: string, ignoreSign = false) => {
  if (canEditLoanApplication(ignoreSign)) return true
  if (!borrowerSeperator || !borrowerSeperator.includes('coBorrower')) return false
  const { borrower } = store.getState()
  const b = borrower?.[borrowerSeperator]
  return !!b && b.isIncluded !== false && !b.signedDate
}

export const canEditLoanStructureDetail = () => {
  let rlt = true
  const { auth, loanDetail } = store.getState()
  if (loanDetail.rateData.locked) rlt = false
  if (!loanDetail.restructureApplicationRelease) rlt = false
  const matched = auth?.role?.role?.permissions?.find(
    (permissionName: string) => permissionName === 'Loan.Detail.Override',
  )
  if (matched) rlt = true
  return rlt
}

export const canEditCreditScore = () => {
  let rlt = true
  const { auth, loanDetail } = store.getState()
  if (loanDetail.submitToLoanSetup != 0) rlt = false
  const matched = auth?.role?.role?.permissions?.find(
    (permissionName: string) => permissionName === 'Loan.Detail.Override',
  )
  if (matched) rlt = true
  return rlt
}
